import { useContext, useEffect, useState, type FC } from "react";
import { ExpandedContext } from "../contexts/Expanded";
import { HiMagnifyingGlass, HiMiniBars3BottomLeft } from "react-icons/hi2";
import { FiPower } from "react-icons/fi";
import { asyncLocalStorage, clearStorage } from "../utils/storage";
import { LoadingContext } from "../contexts/LoadingContext";
import { SearchContext } from "../contexts/SearchContext";
import { Admin } from "../models/system/admin";
import { PROFILE, ROLE_NAME } from "../objects/constants";

interface TopBarProps {}

const TopBar: FC<TopBarProps> = ({}) => {
  const { isExpanded, setIsExpanded } = useContext(ExpandedContext);
  const { isLoading, setIsLoading } = useContext(LoadingContext);
  const { search, setSearch } = useContext(SearchContext);
  const [roleName, setRoleName] = useState("");
  const [profile, setProfile] = useState<Admin>();

  useEffect(() => {
    asyncLocalStorage.getItem(PROFILE).then((data) => {
      if (data) {
        setProfile(JSON.parse(data));
      }
    });
    asyncLocalStorage.getItem(ROLE_NAME).then((data) => {
      if (data) {
        setRoleName(data);
      }
    });
  }, []);
  return (
    <div className="topbar  text-gray-700 py-4 px-3 flex items-center justify-between">
      <div className="flex items-center">
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="focus:outline-none pr-4"
        >
          <HiMiniBars3BottomLeft />
        </button>
        <div className="relative">
          <input
            type="text"
            placeholder="Search"
            className="focus:outline-none border  border-gray-300 rounded-3xl py-[7px] text-sm px-3 w-64"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <button
            type="submit"
            className="absolute right-2 top-1/2 transform -translate-y-1/2"
          >
            <HiMagnifyingGlass />
          </button>
        </div>
      </div>
      <div className="flex flex-row gap-2 items-center">
        <div className="bg-white px-4 py-1 rounded-3xl hover:shadow-lg hover:shadow-gray-200 flex flex-row gap-2 items-center cursor-pointer">
          <div className="flex flex-col items-end">
            <span className="text-gray-600 text-sm font-semibold">{profile?.full_name}</span>
            <span className="text-xs">{roleName}</span>
          </div>
          {profile?.profile_picture?.url && (
            <img
              src={profile?.profile_picture?.url}
              className="w-8 h-8 rounded-full"
            />
          )}
        </div>
        <button onClick={() => clearStorage()} className="focus:outline-none">
          <FiPower className="hover:text-red-500 transition-colors" />
        </button>
      </div>
    </div>
  );
};
export default TopBar;
